import { demAuthHandlers } from './auth';
import { demoBotsHandlers } from './bots';
import { demoPortfolioHandlers } from './portfolio';
import { demoOrdersHandlers } from './orders';
import { demoSystemHandlers } from './system';
import { demoExchangeAccountsHandlers } from './exchange-accounts';
import { demoBacktestsHandlers } from './backtests';
import { demoMiscHandlers } from './misc';
import { demoMfaHandlers } from './mfa';
import { demoSessionsHandlers } from './sessions';
import { demoVenueConnectionsHandlers } from './venue-connections';
import { demoExecutionProfilesHandlers } from './execution-profiles';
import { demoWalletsHandlers } from './wallets';
import { demoLedgerHandlers } from './ledger';
import { demoMarketDataHandlers } from './market-data';
import { demoFeatureFlagsHandlers } from './feature-flags';
import { demoSecurityEventsHandlers } from './security-events';
import { demoKillSwitchHandlers } from './kill-switch';

/**
 * All demo MSW handlers, composed in priority order.
 * MSW uses the first matching handler, so more specific handlers should come first.
 */
export const demoHandlers = [
  ...demAuthHandlers,
  ...demoMfaHandlers,
  ...demoSessionsHandlers,
  ...demoBotsHandlers,
  ...demoPortfolioHandlers,
  ...demoOrdersHandlers,
  ...demoSystemHandlers,
  ...demoKillSwitchHandlers,
  ...demoExchangeAccountsHandlers,
  ...demoVenueConnectionsHandlers,
  ...demoExecutionProfilesHandlers,
  ...demoWalletsHandlers,
  ...demoLedgerHandlers,
  ...demoMarketDataHandlers,
  ...demoFeatureFlagsHandlers,
  ...demoSecurityEventsHandlers,
  ...demoBacktestsHandlers,
  ...demoMiscHandlers,
];
